import React, { useMemo } from "react";
import { Dropdown as BootDropdown, Col, Form, Row } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { useSource } from "../../../sourceContext";
// import { initMem } from "../../../../../services/dataSource";

export function Dropdown({ idx, name, label, source:sourceAddress, parentSource, parent, parentAddress }) {
  const {[idx]:block} = useControl()
  const controlReducer = useControlReducer()
  const source = useSource()

  const selected = useMemo(() => {
    // console.log('selected with source', source)
    return source[sourceAddress] && source[sourceAddress].find(itm => ((block[name] === (itm && itm._id)) || (block[name] === itm)))
  }, [source, block, name, sourceAddress])

  const menuOptions = useMemo(() => {
    const mapOptions = (itm, i)=> {
      const label = (itm && typeof itm === 'object') ? (itm.name || itm._name || itm._id) : String(itm)
      const value = (itm && typeof itm === 'object') ? (itm._id || itm) : itm
      return (<BootDropdown.Item key={i} eventKey={`${i}`} value={value}>{label}</BootDropdown.Item>)
    }
    if(!parent){
      return source[sourceAddress] && source[sourceAddress].map(mapOptions)
    }
    return block[parent] && source[sourceAddress].filter(itm=>itm[parentAddress] === block[parent]).map(mapOptions)

  }, [source, block, parent, parentAddress, sourceAddress])

  function onChange(selectedKey, evt) {
    // let val = parseInt(evt.target.value, 10)
    // console.log('dropdown onChange', name, selectedKey, evt.target.value, val, evt.target.props)
    let newVal = selectedKey || selectedKey === 0 ? menuOptions[selectedKey].props.value : 
      (source[sourceAddress][0] && (source[sourceAddress][0]._id || source[sourceAddress][0]))
    // console.log('updating dropdown', newVal)
    controlReducer({ idx, name, type: 'changed', update:{[name]: newVal } })
  }
  // console.log('rendering dropdown', name, menuOptions, source)
  const labelElm = label ? (
    <Col sm="4">
      <Form.Label>{label}</Form.Label>
    </Col>
  ) : []

  return (
    <Row style={{padding: '4px 0', width:'100%'}}>
      {labelElm}
      <Col sm>
        <BootDropdown onSelect={(eventKey, evt)=>{
          // console.log('pre onChange dropdown', eventKey)
          onChange(eventKey, evt)
          }} drop="right">
          <BootDropdown.Toggle variant="outline-info" style={{ width: '100%' }} >
            {selected ? `${(typeof selected === 'object') ? (selected.name || selected._name || selected._id) : String(selected)}` :  `Select an option`}
          </BootDropdown.Toggle>
          <BootDropdown.Menu popperConfig={{strategy:'fixed'}} renderOnMount={true} align="end">
            <div style={{maxHeight: 300, overflowY:'auto'}}>
              {menuOptions}
            </div>
          </BootDropdown.Menu>
        </BootDropdown>
      </Col>
    </Row>
  )
}